'use client';

/**
 * The `nonPurchasable` branch of RN's `primaryActions`
 * (`src/flows/pdp/content.tsx`): an "unavailable" message + an "Explore
 * Other Items from this Seller" button.
 *
 * RN navigates to the seller's bio via `useOpenBio`. On the standalone web
 * route the visitor arrived from that bio (soft-nav) or via a permalink, so
 * `history.back()` returns them to where they can browse the seller — a
 * faithful, dependency-free stand-in until bio deep-linking is wired.
 *
 * Note: `nonPurchasable` is a runtime-only field on RN's listing and isn't
 * present on the public `Listing` model, so this branch is effectively
 * unreachable today; it's kept for RN parity.
 */
export function NonPurchasableActions() {
  return (
    <div className="space-y-2.5 py-2 text-center">
      <p className="text-label font-medium text-zinc-500">
        This product is unavailable for purchase.
      </p>
      <button
        type="button"
        onClick={() => window.history.back()}
        className="text-sub block w-full rounded-lg bg-neutral-900 px-4 py-3 text-white transition-opacity hover:opacity-95"
      >
        Explore Other Items from this Seller
      </button>
    </div>
  );
}
